export const t2HeadCells = [
  { id: "name", numeric: false, disablePadding: true, label: "Employee Name" },
  {
    id: "startTime",
    numeric: true,
    disablePadding: false,
    label: "Start Time",
  },
  { id: "endTime", numeric: true, disablePadding: false, label: "End Time" },
  {
    id: "clockInTime",
    numeric: true,
    disablePadding: false,
    label: "Clockin Time",
  },
  {
    id: "clockInLocation",
    numeric: true,
    disablePadding: false,
    label: "Clockin Location",
  },
  {
    id: "clockOutTime",
    numeric: true,
    disablePadding: false,
    label: "Clockout Time",
  },
  {
    id: "clockOutLocation",
    numeric: true,
    disablePadding: false,
    label: "Clockout Location",
  },
  {
    id: "editTimesheet",
    numeric: true,
    disablePadding: false,
    label: "Edit Timesheet",
  },
];
